import React from 'react';
import { PublicUser } from '../../types';
import { getAvatarImageUrl } from '../../utils/avatar';
import { getUserEmoji } from '../../utils/emoji';
import EmojiIcon from './EmojiIcon';

interface UserAvatarProps {
  user?: PublicUser | null;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizes = {
  sm: 'h-7 w-7 text-sm rounded-xl',
  md: 'h-10 w-10 text-xl rounded-2xl',
  lg: 'h-12 w-12 text-2xl rounded-2xl',
};

const UserAvatar: React.FC<UserAvatarProps> = ({ user, size = 'md', className = '' }) => (
  <div className={`grid shrink-0 place-items-center overflow-hidden bg-gradient-to-br from-cyan-400 to-violet-500 shadow-sm ring-1 ring-white/40 ${sizes[size]} ${className}`}>
    {user?.avatarImage ? (
      <img src={getAvatarImageUrl(user.avatarImage)} alt="" className="h-full w-full object-cover" />
    ) : (
      <EmojiIcon emoji={getUserEmoji(user ?? { id: 0 })} className="h-[65%] w-[65%]" />
    )}
  </div>
);

export default UserAvatar;
